import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import bigscreen from './modules/bigscreen'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    bigscreen
  },
  state: {
    myuuid:'',
  },
  mutations: {
    setMyuuid(state,myuuid){
      sessionStorage.setItem('myuuid',myuuid);
      state.myuuid = myuuid;
    }
  },
  actions: {

  },
  getters
})
